
import { defineComponent, onBeforeMount } from 'vue'

import IRouterNames from '@/retail/application/types/config/router'

import PLink from '@invivodf/common/src/application/presenters/PLink/PLink.vue'

import { useProductList } from '../../composables/useProductList'

export default defineComponent({
  name: 'CCatalog',
  components: {
    PLink,
  },
  setup() {
    const { productList, loadProductList } = useProductList()

    onBeforeMount(loadProductList)

    return { IRouterNames, productList }
  },
})
